import Btn from '../utils/btn';

const func = $target => {

    var $ordersTable = $target.find('.dataTable'),
        $type = $target.find('input[name="type"]');

    window.loader.keys(['numeral'], function() {

        var $submitBtn = $target.find('button[type="submit"]:not([data-id="save-preferences"])'),
            $paymentBtn = new Btn($target.find('[data-id="payment"]')),
            $form = $target.find('form:not([data-id="save-preferences"])'),
            // $productCheckboxes = $target.find('[id*="dsdProductIds-"]'),
            $btnsContainer = $target.find('[data-id="btnsContainer"]'),
            $paymentContainer = $target.find('[data-id="payment-container"]'),
            $totalContainerEur = $target.find('[data-id="total-eur"]'),
            $totalContainerUsd = $target.find('[data-id="total-usd"]'),

            $totalOustandingContainerEur = $target.find('[data-id="total-outstanding-eur"]'),
            $totalOutstandingContainerUsd = $target.find('[data-id="total-outstanding-usd"]'),

            $unpaidAlert = $target.find('[data-id="unpaid-alert"]'),
            $invoicesMessages = $target.find('[data-id="invoices-message"]'),
            displayUnpaidAlert = $ordersTable.find('tfoot').data('display-unpaid-alert');

        document.querySelectorAll('[type="date"]').forEach((datePicker) => {
            datePicker.onclick = () => {
                try {
                    datePicker.showPicker();
                } catch(error) {
                    console.log(error);
                }
            };
        });

        numeral.defaultFormat('0,0.00');

        if (displayUnpaidAlert) {
            $unpaidAlert.toggleClass('d-flex d-none');
        }
        
        $target.on('change', '[id*="dsdProductIds-"]', function() {
            if ($target.find('[id*="dsdProductIds-"]:checked').length) {
                if ($btnsContainer.hasClass('d-none')) {
                    $btnsContainer.toggleClass('d-block d-none');
                    $paymentBtn.enable();
                }
            } else {
                $btnsContainer.toggleClass('d-none d-block');
                $invoicesMessages.addClass('d-none');
                $paymentBtn.disable();
            }

            calculateTotal();
        });

        $('#selectAll').change(function() {
            var $productCheckboxes = $target.find('[id*="dsdProductIds-"]');

            if ($(this).is(':checked')) {
                $productCheckboxes.prop('checked', true);

                if ($btnsContainer.hasClass('d-none')) {
                    $btnsContainer.toggleClass('d-block d-none');
                    $paymentBtn.enable();
                }
            } else {
                $productCheckboxes.prop('checked', false);
                $btnsContainer.toggleClass('d-none d-block');
                $invoicesMessages.addClass('d-none');
                $paymentBtn.disable();
            }

            calculateTotal();
        });

        $submitBtn.on('click',function(e) {
            e.preventDefault();
            var buttonType = $(this).data('id');

            $type.val(buttonType);

            if (buttonType == 'invoices') {
                $invoicesMessages.removeClass('d-none');
                setTimeout(function() {
                    $invoicesMessages.hide('d-none');
                }, 5000); 
            } else if (buttonType == 'payment') {
                $paymentBtn.process();
            }

            $form.submit();
        });

        function calculateTotal() {
            var totalEur = 0,
                totalUsd = 0,
                totalOutstandingEur = 0,
                totalOutStandingUsd = 0;

            $totalContainerEur.html(numeral(totalEur).format());
            $totalContainerUsd.html(numeral(totalUsd).format());
                
            $totalOustandingContainerEur.html(numeral(totalOutstandingEur).format());
            $totalOutstandingContainerUsd.html(numeral(totalOutStandingUsd).format());
    
            $('[id*="dsdProductIds-"]:checked').each(function() {
                var $this = $(this);

                //  update totals
                if ($this.data('currency') == 'EUR') {
                    totalEur += $this.data('amount');
                    $totalContainerEur.html(numeral(totalEur).format());
                } else {
                    totalUsd += $this.data('amount');
                    $totalContainerUsd.html(numeral(totalUsd).format());
                }
                
                // update outstanding totals
                if ($this.data('currency') == 'EUR') {
                    totalOutstandingEur += ($this.data('outstanding') ? $this.data('outstanding') : 0);
                    $totalOustandingContainerEur.html(numeral(totalOutstandingEur).format());
                } else {
                    totalOutStandingUsd += ($this.data('outstanding') ? $this.data('outstanding') : 0);
                    $totalOutstandingContainerUsd.html(numeral(totalOutStandingUsd).format());
                }
            });
    
            if(totalOutstandingEur > 0 && totalOutStandingUsd > 0) { 
                $paymentBtn.disable();

                if(!$('.currency-error')[0]) {               
                    $('[data-mod="orderManagement"]').append('<div class="alert alert-danger currency-error error text-center">Payments can only be processed in one currency at a time.</div>');
                }
            } else {
                $('.currency-error').remove();
            }

            if(totalOutstandingEur > 0 || totalOutStandingUsd > 0) { 
                $paymentBtn.enable();
                $paymentContainer.removeClass('d-none');
                
            } else {
                $paymentContainer.addClass('d-none');
                $paymentBtn.disable();
            }
    
            return totalOutstandingEur + totalOutStandingUsd;
        }
    });

    if ($ordersTable[0]) {

        var $orderStartDate = $target.find('[data-id="order-start-date"]'),
            $orderEndDate = $target.find('[data-id="order-end-date"]'),
            $orderDateFilters = $target.find('.orderDateFilters'),
            $invoiceStartDate = $target.find('[data-id="invoice-start-date"]'),
            $invoiceEndDate = $target.find('[data-id="invoice-end-date"]'),
            $invoiceDateFilters = $target.find('.invoiceDateFilters'),
            $orderReferenceFilter = $target.find('#orderReferenceFilter'),
            $productTypeFilter = $target.find('#productTypeFilter'),
            $caseFilter = $target.find('#caseFilter'),
            $patientFilter = $target.find('#patientFilter'),
            $productStatusFilter = $target.find('#productStatusFilter'),
            $paidStatusFilter = $target.find('#paidStatusFilter'),
            $invoiceStatusFilter = $target.find('#invoiceStatusFilter'),
            $paymentTypeFilter = $target.find('#paymentTypeFilter'),
            $resetFilters = $target.find('[data-id="reset-filters"]'),
            $dataPreferences = $target.find('[data-id="save-preferences"]').attr('data-preferences');        

        window.loader.key('selectize', function() {
            var $caseFilterSelectize = $caseFilter.selectize({
                create: false,
            })[0].selectize;

            var $patientFilterSelectize = $patientFilter.selectize({
                create: false,
            })[0].selectize;

            $resetFilters.on('click',function() {
                $orderStartDate.val('');
                $orderEndDate.val('');
                $invoiceStartDate.val('');
                $invoiceEndDate.val('');
                $caseFilterSelectize.clear();
                $patientFilterSelectize.clear();
                $orderReferenceFilter.val('').trigger('change');
                $productStatusFilter.val('').trigger('change');
                $paidStatusFilter.val('').trigger('change');
                $invoiceStatusFilter.val('').trigger('change');
                $paymentTypeFilter.val('').trigger('change');
                $productTypeFilter.val('').trigger('change');
            });
        });

        window.loader.key('datatables', function() {

            var table = $ordersTable.DataTable({
                responsive: true,
                pageLength: 50,
                fixedHeader: true,
                columnDefs: [
                    { targets: [10], orderable: false } // Disable sorting for column 10
                ]
            });

            function formatDate(date) {
                var yyyy = date.getFullYear();
                var mm = ('0' + (date.getMonth() + 1)).slice(-2);
                var dd = ('0' + date.getDate()).slice(-2);

                return yyyy + '-' + mm + '-' + dd;
            }

            $orderDateFilters.on('click',function(e) {
                e.preventDefault();

                var startDate = $(this).data('startdate');
                var endDate = $(this).data('enddate');

                $orderStartDate.val(startDate).trigger('change');
                $orderEndDate.val(endDate).trigger('change');
            });

            $invoiceDateFilters.on('click',function(e) {
                e.preventDefault();

                var startDate = $(this).data('startdate');
                var endDate = $(this).data('enddate');              

                $invoiceStartDate.val(startDate).trigger('change');
                $invoiceEndDate.val(endDate).trigger('change');               
            });

            $('.order-date-selector, .invoice-date-selector, #productTypeFilter, #paidStatusFilter, #orderReferenceFilter, #productStatusFilter, #invoiceStatusFilter, #caseFilter, #patientFilter, #paymentTypeFilter').on('input change', function(e) {                
                var orderStartDate = $orderStartDate.val().replace(/-/g, ''),
                    orderEndDate = $orderEndDate.val().replace(/-/g, ''),
                    invoiceStartDate = $invoiceStartDate.val().replace(/-/g, ''),
                    invoiceEndDate = $invoiceEndDate.val().replace(/-/g, ''),
                    productType = $productTypeFilter.val(),
                    orderReference = $orderReferenceFilter.val().toLowerCase(),
                    paidStatus = $paidStatusFilter.val(),
                    productStatus = $productStatusFilter.val(),
                    invoiceStatus = $invoiceStatusFilter.val(),
                    paymentType = $paymentTypeFilter.val(),
                    caseFilter = $caseFilter.val(),
                    patientFilter = $patientFilter.val(),
                    $this = $(this);

                let orderDataPattern = '';

                if (orderReference && productStatus) {
                    orderDataPattern = `(?=.*${orderReference})(?=.*${productStatus})`;
                } else if (orderReference) {
                    orderDataPattern = orderReference;
                } else if (productStatus) {
                    orderDataPattern = productStatus;
                }

                // product status
                // table.columns(0).search(productStatus);
                table.columns(0).search(orderDataPattern, true, false);

                $.fn.dataTable.ext.search.push(
                    function(settings, searchData, index) {
                        var orderDateAttr = searchData[1];
                        var invoiceDateAttr = searchData[2];
                        
                        if ((orderStartDate && orderDateAttr < orderStartDate) || (orderEndDate && orderDateAttr > orderEndDate)) {
                            return false;
                        }

                        if ((invoiceStartDate && invoiceDateAttr < invoiceStartDate) || (invoiceEndDate && invoiceDateAttr > invoiceEndDate)) {
                            return false;
                        }

                        return true;
                    }
                );

                //  order date
                // $.fn.dataTable.ext.search.push(
                //     function(settings, searchData) {
                //         var orderDateAttr = searchData[1];

                //         if (orderDateAttr) {
                //             if (orderStartDate === '' || orderEndDate === '' || (orderDateAttr >= orderStartDate && orderDateAttr <= orderEndDate)) {       
                //                 return true;
                //             }
                //         }

                //         return false;
                //     }
                // );

                // // invoice date
                // $.fn.dataTable.ext.search.push(
                //     function(settings, searchData, index, rowData, counter) {
                //         var invoiceDateAttr = searchData[2];

                //         if (invoiceDateAttr) {
                //             if  (invoiceStartDate === '' || invoiceEndDate === '' || (invoiceDateAttr >= invoiceStartDate && invoiceDateAttr <= invoiceEndDate)) {
                //                 return true;
                //             }
                //         }

                //         return false;
                //     }
                // );

                // invoice status
                table.columns(3).search(invoiceStatus);

                // product type
                table.columns(5).search(productType);

                // case filter
                if ($this.attr('id') == 'caseFilter') {
                    table.columns(6).search(caseFilter);
                }

                // patient filter
                if ($this.attr('id') == 'patientFilter') {
                    table.columns(6).search(patientFilter);
                }

                // paid status
                if (paidStatus == '') {
                    table.columns(9).search(paidStatus);
                } else {
                    var regex = `^${paidStatus}$`;
                    table.column(9).search(regex, true, false);
                }

                table.columns(10).search(paymentType);               
            
                table.draw();
                $.fn.dataTable.ext.search.pop();
            })

            // set default status
            table.columns(3).search('invoiced', true, false).draw();
            table.columns(9).search('^(unpaid|partial)$', true, false).draw();

             // set order preferences if any change 1
            if ($dataPreferences) {

                console.log($dataPreferences);

                const dropdowns = {
                    invoiceStatusFilter: $invoiceStatusFilter,
                    paidStatusFilter: $paidStatusFilter,
                    paymentTypeFilter: $paymentTypeFilter,
                    productTypeFilter: $productTypeFilter,
                    productStatusFilter: $productStatusFilter
                };

                $.each(JSON.parse($dataPreferences), function(name, value) {
                    if (dropdowns[name]) {
                        console.log('set ' + name +  ': ' + value);

                        dropdowns[name].val(value).trigger('change');
                    }
                });
            }

        });
    }

};

export default func;